@if (isCollapsed()) {
  <span class="mat-title-large --bold">YP</span>
} @else {
  <span class="mat-title-medium --bold">YP BUYER'S <br />PORTAL</span>
}
